import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VrpanoIcon(props: IconProps) {
    return <Icon {...props} iconKey={"vrpano"}/>
}
